import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from 'utils/services';

import { GetShopPageReq, GetShopPageRes } from './shopPage.types';
import { normalizeShopPageResponse } from './shopPage.normalizer';

export const shopPageApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getShopPage: build.query<GetShopPageRes, GetShopPageReq>({
      query: (arg) => ({
        params: arg?.slug ? { slug: arg.slug } : undefined,
        url: '/shop/page'
      }),
      transformResponse: normalizeShopPageResponse
    })
  }),
  reducerPath: 'shopPageApi'
});

export const { useGetShopPageQuery } = shopPageApi;
